import React from 'react'

interface IProps {
  isPaymentDetails: any
}

const PaymentDetails: React.FC<IProps> = ({ isPaymentDetails }) => {
  return (
    <div className='d-flex flex-column w-100 mt-3'>
      <div className='table-responsive rounded-2'>
        <table className='table table-striped border border-muted'>
          <tbody>
            <tr>
              <td className='p-3'>
                <div className='d-flex mt-4'>
                  <label className='w-50 fw-bolder'>Payment Reference Id:</label>
                  <p> {isPaymentDetails?.paymentReferenceID}</p>
                </div>
              </td>
            </tr>
            <tr>
              <td className='p-3'>
                <div className='d-flex mt-4 '>
                  <label className='w-50 fw-bolder'>Payment Bank Name:</label>
                  <p> {isPaymentDetails?.paymentBankname}</p>
                </div>
              </td>
            </tr>
            <tr>
              <td className='p-3'>
                <div className='d-flex mt-4 '>
                  <label className='w-50 fw-bolder'>Currency Type:</label>
                  <p> {isPaymentDetails?.currencyType}</p>
                </div>
              </td>
            </tr>
            <tr>
              <td className='p-3'>
                <div className='d-flex mt-4'>
                  <label className='w-50 fw-bolder'>Payment Other Details:</label>
                  <p> {isPaymentDetails?.paymentBankOtherDetails}</p>
                </div>
              </td>
            </tr>
            <tr>
              <td className='p-3'>
                <div className='d-flex mt-4'>
                  <label className='w-50 fw-bolder'>Amount Paid:</label>
                  <p> {isPaymentDetails?.amountPaid}</p>
                </div>
              </td>
            </tr>
            <tr>
              <td className='p-3'>
                <div className='d-flex mt-4'>
                  <label className='w-50 fw-bolder'>Discount Amount:</label>
                  <p> {isPaymentDetails?.discountAmount}</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default PaymentDetails
